export default __webpack_public_path__ + "static/media/36.645e31dd.jpg";